/* @flow */

// Helper function to shuffle an array manually
export function shuffleArray(unshuffledArray: any) {
    return unshuffledArray
        .map((value) => ({value, sort: Math.random()}))
        .sort((a, b) => a.sort - b.sort)
        .map(({value}) => value);
}
